import React from 'react'
import Navigation from './components/Navigation'
import './App.css'
import Footer from './components/Footer';
import { BrowserRouter as Router } from 'react-router-dom';

import TagManager from 'react-gtm-module'
const tagManagerArgs = {
  gtmId: 'GTM-WVJ853R'
}
TagManager.initialize(tagManagerArgs)

const App = () => {
  return (
    <Router>
      <Navigation />
      <Footer />
    </Router>
  );
}

export default App